"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_GROUPS_CHANGED = exports.WS_ADD_INVITATION = exports.WS_CHANGED_DASHBOARDS_WEB = exports.WS_CHANGED_DASHBOARDS_MOBILE = exports.WS_CHANGED_DASHBOARDS = exports.WS_CHANGED_WEB = exports.WS_CHANGED_MOBILE = exports.WS_SIGNOUT = exports.WS_DISCONNECT = exports.WS_CONNECT = exports.WS_AUTHORISE = exports.SM_SUBSCRIBE = exports.SM_REQUIRE_SOCKET = exports.SM_IS_MOCK = exports.SM_IS_CONNECTED = exports.SM_GET_SOCKET = exports.SM_GET_ID = exports.SM_DISCONNECT = void 0;

/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
// Manager events.
var SM_DISCONNECT = 'SM_DISCONNECT';
exports.SM_DISCONNECT = SM_DISCONNECT;
var SM_GET_ID = 'SM_GET_ID';
exports.SM_GET_ID = SM_GET_ID;
var SM_GET_SOCKET = 'SM_GET_SOCKET';
exports.SM_GET_SOCKET = SM_GET_SOCKET;
var SM_IS_CONNECTED = 'SM_IS_CONNECTED';
exports.SM_IS_CONNECTED = SM_IS_CONNECTED;
var SM_IS_MOCK = 'SM_IS_MOCK';
exports.SM_IS_MOCK = SM_IS_MOCK;
var SM_REQUIRE_SOCKET = 'SM_REQUIRE_SOCKET';
exports.SM_REQUIRE_SOCKET = SM_REQUIRE_SOCKET;
var SM_SUBSCRIBE = 'SM_SUBSCRIBE'; // WebSocket events.

exports.SM_SUBSCRIBE = SM_SUBSCRIBE;
var WS_AUTHORISE = 'authorise';
exports.WS_AUTHORISE = WS_AUTHORISE;
var WS_CONNECT = 'connect';
exports.WS_CONNECT = WS_CONNECT;
var WS_DISCONNECT = 'disconnect';
exports.WS_DISCONNECT = WS_DISCONNECT;
var WS_SIGNOUT = 'signout';
exports.WS_SIGNOUT = WS_SIGNOUT;
var WS_CHANGED_MOBILE = 'credential_changed_mobile';
exports.WS_CHANGED_MOBILE = WS_CHANGED_MOBILE;
var WS_CHANGED_WEB = 'credential_changed_web';
exports.WS_CHANGED_WEB = WS_CHANGED_WEB;
var WS_CHANGED_DASHBOARDS = 'dashboard_space_changed';
exports.WS_CHANGED_DASHBOARDS = WS_CHANGED_DASHBOARDS;
var WS_CHANGED_DASHBOARDS_MOBILE = 'dashboard_space_changed_mobile';
exports.WS_CHANGED_DASHBOARDS_MOBILE = WS_CHANGED_DASHBOARDS_MOBILE;
var WS_CHANGED_DASHBOARDS_WEB = 'dashboard_space_changed_web';
exports.WS_CHANGED_DASHBOARDS_WEB = WS_CHANGED_DASHBOARDS_WEB;
var WS_ADD_INVITATION = 'pending_invitations';
exports.WS_ADD_INVITATION = WS_ADD_INVITATION;
var WS_GROUPS_CHANGED = 'groups_changed';
exports.WS_GROUPS_CHANGED = WS_GROUPS_CHANGED;